<button mat-icon-button
        class="nav-button"
        color="primary"
        (click)="onChangeClicked(-1)">
    <mat-icon class="left">arrow_left</mat-icon>
</button>
<div class="week-container">
    <button mat-button
            [matMenuTriggerFor]="menu">
        <div class="title">
          <span *ngIf="date; else loadingWeek">{{ 'Week_x' | translate:{x: (date|appDate:'w') || '1'} }}</span>
          <ng-template #loadingWeek>{{ 'Loading' | translate }}...</ng-template>
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
    </button>
    <mat-menu #menu="matMenu"
              xPosition="before"
              (closed)="updateYearMenu()">
        <div class="year-week-header">
            <button mat-icon-button
                    (click)="onChangeYearClicked($event, -1)">
                <mat-icon class="right">arrow_left</mat-icon>
            </button>
            <div class="title">{{ year }}</div>
            <button mat-icon-button
                    (click)="onChangeYearClicked($event, 1)">
                <mat-icon class="right">arrow_right</mat-icon>
            </button>
        </div>
        <button *ngFor="let week of yearWeeks"
                mat-menu-item
                class="week"
                [class.selected-week]="week.fromDate.getTime() == fromDate?.getTime()"
                [class.current-week]="week.fromDate.getTime() == todayWeekDate.getTime()"
                (click)="onSelectWeek(week.fromDate)">
            <div class="year-week-button">
                <div>{{ 'Week_x' | translate:{x: (week.fromDate|appDate:'w')} }}</div>
                <div class="legend">{{ week.fromDate|appDate:'dd.MM.yy' }} - {{ week.toDate|appDate:'dd.MM.yy' }}</div>
            </div>
        </button>
    </mat-menu>
    <div class="subtitle">{{ fromDate??''|appDate:'dd.MM.yy' }} - {{ toDate??''|appDate:'dd.MM.yy' }}</div>
</div>
<button mat-icon-button
        class="nav-button"
        color="primary"
        (click)="onChangeClicked(1)">
    <mat-icon class="right">arrow_right</mat-icon>
</button>
